export function obterListaMdfeTipoTransportador() {
  return (
    [
      { label: '', value: null },
      { label: 'ETC - Empresa de transporte de cargas', value: 'ETC' },
      { label: 'TAC - Transportador autônomo de cargas', value: 'TAC' },
      { label: 'CTC - Cooperativa de transporte de cargas', value: 'CTC' },
    ]
  );
}
